module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAOpJREFUOE+9krFqwlAUhr+TIk6+Qyhxt9BdcHRy0Ln0GVySdOoiGp/Azd3BRQRdXAotxQfwCcRNcIpEOCW2hcQYEwh45//77n/vOULBIwV57iSw1cKgS8A7Q9lFW+dr4OoEaAMbtjwxFv9fcltgq4nBG0ccykyBGgHVaIt0QQgLKwQTZYbPCyUe8WSd/YQo/Jv2OVHHk+/LqSUbXIOhRU8W10YeF3T0AYsvhOe/cPhZqXCYiQtsbSDMUQ4YVLLgpMDVEcoryhKlz0A+sjY13sDRJsonfdlngck9cFXzQudcT86X59vEG+bCgh+ykT8RJ0p9bgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/housework/edit_blue.png
// module id = Nulk
// module chunks = 5